import { useEffect, useMemo, useState } from 'react';
import { Row, Col, Container, } from "react-bootstrap";
import { BzTabsContent, BzTabsContainer, BzChip, BzCard } from "../../components";
import { useSelector, useDispatch } from 'react-redux';
import { getGSMGradeCategory, getSecurityDetails, getCommonCompanyContractData } from '../../redux/actions/marketOverview';
import { WATCHLIST_GRID_INDEX,GSMVALUE } from '../../utils/global_variables';
import { convertToDate, nullCheck } from '../../utils/global_functions';


const CompanyInfo = () => {
    //Vaibhav Singh: 14-12-23: BT-107428: updated '-' and updated spelling mistake : Start
    const dispatch = useDispatch();

    const recordData = useSelector(state => state?.marketOverview?.recordData);
    const gsmCategory = useSelector(state => state?.marketOverview?.gsmCategory);
    const listing = useSelector(state => state.marketOverview.listing);
    const securityDetails = useSelector(state => state?.marketOverview?.securityDetails);
    const objCodeInfo = useSelector(state => state.marketOverview.objCodeInfo);
    const arrExchangeData = useSelector(state => state?.marketOverview?.arrExchangeData);
    const arrDirectorData = useSelector(state => state?.marketOverview?.arrDirectorData);
    const objCompanyBackgroundData = useSelector(state => state.marketOverview.objCompanyBackgroundData);
    const objCompanyHistory = useSelector(state => state?.marketOverview?.objCompanyHistory);
    const scripOverviewData = useSelector(state => state?.marketOverview.scripOverviewData);
    const availableExchanges = useSelector(state => state?.marketOverview.availableExchanges);
    const [companyActiveChip, setCompanyActiveChip] = useState("register_adress");
    const [showMore, setShowMore] = useState(true);
    // Vaibhav Singh: 30-01-24: BT-107248: validattion upadted: Start
    // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- Start
    const companyListed = nullCheck(arrExchangeData?.length > 0 ? arrExchangeData?.map((item) => item?.Sector_Names)?.join(', ') : null);
    // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- End
    let register;
    if (objCompanyBackgroundData?.regAddress1 && objCompanyBackgroundData?.regAddress2 && objCompanyBackgroundData?.regCity && objCompanyBackgroundData?.regPin) {
        register = objCompanyBackgroundData?.regAddress1 + ',' + objCompanyBackgroundData?.regAddress2 + ',' + objCompanyBackgroundData?.regCity + ',' + objCompanyBackgroundData?.regPin;
    } else {
        register = 'NA';
    }
    const registrar = Object.keys(objCompanyBackgroundData)?.length ? objCompanyBackgroundData?.address1 + ',' + objCompanyBackgroundData?.address2 + ',' + objCompanyBackgroundData?.address3 + ',' + objCompanyBackgroundData?.address4 : 'NA';
    const headOffice = objCompanyBackgroundData?.hoa1 + ',' + objCompanyBackgroundData?.hoa2 + ',' + objCompanyBackgroundData?.hoa3 + ',' + objCompanyBackgroundData?.hoc + ',' + objCompanyBackgroundData?.hop + ',' + objCompanyBackgroundData?.hot;
    const headOfficeAddr = Object.keys(objCompanyBackgroundData)?.length ? (headOffice !== '-,-,-,-,-,-') ? headOffice : 'NA' : 'NA';
    const priceValue = (securityDetails?.priceTick / scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toFixed(2);
    const faceValue = (securityDetails?.faceValue / scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toFixed(2);
    const quantityfreeze = (securityDetails?.qtyFreeze / scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toFixed(2) + '%';
    const marginvalue = (securityDetails?.margin / scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toFixed(2) + '%';
    const gsmExhcangeType = scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE];
    // Vaibhav Singh: 30-01-24: BT-107248: validattion upadted: End
    const toggleReadMore = () => {
        setShowMore(!showMore);
    };

    // Vinit R - 03-04-2024 Company Info to be kept common irrespective of exchanges -- Start
    useEffect(() => {
        if (Object.keys(securityDetails).length === 0) {
            dispatch(getSecurityDetails({ mktSegmentId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID], token: scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] === 0 ? scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN] : scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] }));
        } else { }
    }, [dispatch, scripOverviewData, securityDetails]);

    useEffect(() => {
        if (scripOverviewData?.length > 0) {
            if (Object.keys(gsmCategory).length === 0 ||
                Object.keys(listing).length === 0 ||
                Object.keys(arrExchangeData).length === 0 ||
                Object.keys(arrDirectorData).length === 0 ||
                Object.keys(objCompanyBackgroundData).length === 0 ||
                Object.keys(objCompanyHistory).length === 0) {
                dispatch(getGSMGradeCategory({
                    mktSegmentId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                    nToken: scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] === 0 ? scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN] : scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN],
                }));
            } else { }
        } else { }
    }, [scripOverviewData]);

    // Vinit R - 18-04-2024 Company Info to be kept common irrespective of exchanges -- Start
    useEffect(() => {
        if (availableExchanges?.length > 0) {
            dispatch(getCommonCompanyContractData(availableExchanges));
        }
    }, [scripOverviewData, availableExchanges]);
    // Vinit R - 18-04-2024 Company Info to be kept common irrespective of exchanges -- End

    const [gsmCategoryState, setGsmCategoryState] = useState();
    //Vaibhav Singh: 04-12-2023: BT-107248: UseState defined for showing: Start
    const [showInfo, setShowInfo] = useState(null);
    //Vaibhav Singh: 04-12-2023: BT-107248: UseState defined for showing: End

    useEffect(() => {
        if (gsmCategory?.length > 0) {
            const gsmCategoryGrade = gsmCategory[0][0]?.nIssueRate;
            const gsmCategoryValue = (gsmCategoryGrade === GSMVALUE.GSM1 || gsmCategoryGrade === GSMVALUE.GSM2) ? '' : gsmCategoryGrade;
            setGsmCategoryState((gsmExhcangeType === 'NSE' && gsmCategoryGrade === GSMVALUE.GSM2) || (gsmExhcangeType === 'BSE' && gsmCategoryGrade === GSMVALUE.GSM3) ? 'No' : "Yes" + `(${gsmCategoryValue})`);
        } else { }
    }, [gsmCategory, gsmExhcangeType]);

    const nIssueCapital = securityDetails?.issuedCapital;
    const formattedIssueCapiatal = new Intl.NumberFormat('en-In', { minimumFractionDigits: 2 }).format(nIssueCapital);

    let startDate;
    let endDate;
    let exDate;
    if (recordData?.startDate > 0 || recordData?.endDate > 0 || recordData?.exDate > 0) {
        startDate = recordData?.startDate;
        endDate = recordData?.endDate;
        exDate = recordData?.exDate;
    } else {
        startDate = null;
        endDate = null;
        exDate = null;
    }

    const startDateFormat = startDate ? convertToDate(startDate, 'DDMMMYYYY') : null;

    const endDateFormat = endDate ? convertToDate(endDate, 'DDMMMYYYY') : null;

    const exDateFormat = exDate ? convertToDate(exDate, 'DDMMMYYYY') : null;

    //Vaibhav Singh: 04-12-2023: BT-107248: Handle Function for showing: Start
    const handleShow = (i) => {
        if (showInfo === i) {
            return setShowInfo(null);
        }
        setShowInfo(i);
    };
    //Vaibhav Singh: 04-12-2023: BT-107248: Handle Function for showing: End
    const arrCompanyInfo = useMemo(() => [
        {
            id: "register_adress",
            title: "Registered Address",
            tabKey: "register_adress",
            chipContent:
                <Container fluid className='g-0'>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Address</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(register)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Telephone</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrTell)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Fax</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrFax)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Email</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrEmail)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 pt-3 align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Website</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrWebSite)}</div>
                        </Col>
                    </Row>
                </Container>
        },
        {
            id: 'head_office',
            title: "Head Office",
            tabKey: 'head_office',
            chipContent:
                <Container fluid className='g-0'>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Address</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(headOfficeAddr)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Telephone</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.hot)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Fax</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.hof)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Email</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.hoe)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 pt-3 align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Website</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.how)}</div>
                        </Col>
                    </Row>
                </Container>
        },
        {
            id: "register",
            title: "Registrar",
            tabKey: "register",
            chipContent:
                <Container fluid className='g-0'>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Registrar Name</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrarName)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Address</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(registrar)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Telephone</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrTell)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Fax</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrFax)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Email</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrEmail)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Website</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.registrWebSite)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 pt-3 align-items-start'>
                        <Col md={4} className='text-start'>
                            <div className='font-regular font-size2 color-subtext'>Auditor</div>
                        </Col>
                        <Col md={8} className='text-end'>
                            <div className='font-medium font-size2 color-text'>{nullCheck(objCompanyBackgroundData?.auditor)}</div>
                        </Col>
                    </Row>
                </Container>
        }
    ], [objCompanyBackgroundData]);
    // Vaibhav Singh: 30-01-24: BT-107248: whitespace  validattion upadted: Start
    const isWhiteSpaceString = str => !/\S/.test(str);
    // Vaibhav Singh: 30-01-24: BT-107248: whitespace validattion upadted: End

    return (
        <>
            <Container fluid className='p-0 mt-3'>
                <div className='scripoverview-fieldset'>
                    <div className='scripoverview-legend'>COMPANY INFO</div>
                    <div className={`${showMore ? `scripoverview-fieldset-xs` : ``}`}>
                        <div className='mt-3'>
                            {objCompanyHistory?.length > 0 ?
                                (<div className='font-regular font-size3 lineheight-sm text-justify'>{showMore ? objCompanyHistory?.slice(0, 500) : objCompanyHistory}
                                    <span onClick={toggleReadMore} className='Read-or-hide'>
                                        <a href='#' className='font-medium font-size3 ms-2 chips primary-chip'>{showMore ? "Read More" : "Read Less"}</a>
                                    </span>
                                </div>) : (
                                    <div className='zero-state-alerts zero-state-alerts-md'>
                                        <div className='font-regular font-size2 color-nodata'>No data to display</div>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </Container>

            <Container fluid className='p-0 mt-5'>
                <Row className='g-0'>
                    <Col className='pe-3'>
                        <div className='scripoverview-fieldset'>
                            <div className='scripoverview-fieldset-xl'>
                                <div className='scripoverview-legend'>MANAGEMENT</div>
                                <div className='so-management'>
                                    <div className='transparent-card-wrap'>
                                        {arrDirectorData?.length !== 0 && arrDirectorData.map((item, i) => {
                                            return (
                                                <>
                                                    <BzCard key={i} className='transparent-card cursor-pointer bdr-btm' onClick={() => { handleShow(i); }}>
                                                        <Row className='g-0'>
                                                            <Col md={11} className='d-flex flex-column justify-content-start align-items-start'>
                                                                <div className='font-medium font-size4 color-text' key={i}>{item.directorName}</div>
                                                                <div className='font-regular font-size2 color-subtext pt-1'>{item.directorDesignation}</div>
                                                            </Col>
                                                            <Col md={1} className='d-flex justify-content-end align-items-center'>
                                                                <div className={`icon-16 ${(showInfo === i) ? 'icon-arrowdown' : 'icon-arrowright'} icon-dark`}>&nbsp;</div>
                                                            </Col>
                                                        </Row>

                                                        {(showInfo === i) ?
                                                            <div className='d-flex flex-column pt-3'>
                                                                <Row className='g-0 py-1 align-items-start'>
                                                                    <Col md={4} className='text-start'>
                                                                        <div className='font-regular font-size2 color-subtext'>Year</div>
                                                                    </Col>
                                                                    <Col md={8} className='text-end'>
                                                                        <div className='font-medium font-size2 color-text'>{item?.year}</div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className='g-0 py-1 align-items-start'>
                                                                    <Col md={4} className='text-start'>
                                                                        <div className='font-regular font-size2 color-subtext'>Qualification</div>
                                                                    </Col>
                                                                    <Col md={8} className='text-end'>
                                                                        <div className='font-medium font-size2 color-text'>{item?.qualification}</div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className='g-0 py-1 align-items-start'>
                                                                    <Col md={4} className='text-start'>
                                                                        <div className='font-regular font-size2 color-subtext'>Remuneration</div>
                                                                    </Col>
                                                                    <Col md={8} className='text-end'>
                                                                        <div className='font-medium font-size2 color-text'>{parseFloat(item?.remuneration).toFixed(2)}</div>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                            : null}
                                                    </BzCard>
                                                </>
                                            );
                                        })}
                                    </div>
                                    {arrDirectorData?.length === 0 &&
                                        <div className='zero-state-alerts zero-state-alerts-xl'>
                                            <div className='font-regular font-size2 color-nodata'>No data to display</div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className='ps-3'>
                        <div className='scripoverview-fieldset'>
                            <div className='scripoverview-legend'>BASIC DETAILS</div>
                            <Container fluid className='p-0'>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Code</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(objCodeInfo?.code)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Instrument</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(objCodeInfo?.instrument)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 pt-3 align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>ISIN</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(objCodeInfo?.isin)}</div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        <Container fluid className='p-0 mt-5'>
                            <div className='scripoverview-fieldset'>
                                <div className='scripoverview-legend'>SECURITY DETAILS</div>
                                <Container fluid className='p-0'>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Market Lot</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(securityDetails?.marketLot)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Price Tick (Rs.)</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(priceValue)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Issued Capital</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(formattedIssueCapiatal)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Face Value</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(faceValue)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Qty Freeze</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(quantityfreeze)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Margin %</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(marginvalue)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Ex Multiplier</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(securityDetails?.exMultiplier)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Pre Open</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(securityDetails?.preOpen)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Special Pre Open</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(securityDetails?.specialPreOpen)}</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 pt-3 align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Call Auction</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(securityDetails?.callAuction)}</div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </Container>

            <Container fluid className='p-0 mt-5'>
                <Row className='g-0'>
                    <Col className='pe-3'>
                        <div className='scripoverview-fieldset'>
                            <div className='scripoverview-legend'>BOOK CLOSURE / RECORD DATA</div>
                            <Container fluid className='p-0'>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Date</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{startDateFormat}  {nullCheck(endDateFormat)}</div>
                                    </Col>
                                </Row>
                                {recordData &&
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Ex.date</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{nullCheck(exDateFormat?.toUpperCase())}</div>
                                        </Col>
                                    </Row>
                                }
                                {recordData &&
                                    <Row className='g-0 py-3 bdr-btm align-items-start'>
                                        <Col md={4} className='text-start'>
                                            <div className='font-regular font-size2 color-subtext'>Purpose</div>
                                        </Col>
                                        <Col md={8} className='text-end'>
                                            <div className='font-medium font-size2 color-text'>{isWhiteSpaceString(recordData?.sRemarks) ? "-" : nullCheck(recordData?.sRemarks)}</div>
                                        </Col>
                                    </Row>
                                }
                                <Row className='g-0 pt-3 align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>GSM Category</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(gsmCategoryState)}</div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        <div className='scripoverview-fieldset mt-5'>
                            <div className='scripoverview-legend'>CONTACT INFORMATION</div>
                            <div className='submenu-wrapper horizontal-scroll-wrap py-1 mt-3 d-flex justify-content-start'>
                                {arrCompanyInfo?.length && arrCompanyInfo.map((each, i) => (
                                    <BzChip key={i} className={`submenuItem ${each?.id === companyActiveChip ? 'active' : ''}`} onClick={() => {
                                        setCompanyActiveChip(each.id);
                                    }}>
                                        {each.title}
                                    </BzChip>
                                ))}
                            </div>
                            <Container fluid className='p-0 mt-3'>
                                <Row className='g-0'>
                                    <Col>
                                        <BzTabsContainer>
                                            {
                                                arrCompanyInfo?.length && arrCompanyInfo.map((each, i) => (
                                                    <BzTabsContent key={i} tabKey={each.tabKey ? each.tabKey : ''} showDefault={each?.tabKey === companyActiveChip} isActive={each?.tabKey === companyActiveChip}>{each?.chipContent}</BzTabsContent>
                                                ))
                                            }
                                        </BzTabsContainer>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </Col>
                    <Col className='ps-3'>
                        <div className='scripoverview-fieldset'>
                            <div className='scripoverview-legend'>LISTING</div>
                            <Container fluid className='p-0'>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>NSE Symbol</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(listing[0]?.nseSymbol)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>BSE Symbol</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(listing[0]?.bseSymbol)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>BSE Group</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(listing[0]?.bseGroup)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>ISIN</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(listing[0]?.isin)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Listed On</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(companyListed)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 py-3 bdr-btm align-items-start'>
                                    <Col md={4} className='text-start'>
                                        <div className='font-regular font-size2 color-subtext'>Sector</div>
                                    </Col>
                                    <Col md={8} className='text-end'>
                                        <div className='font-medium font-size2 color-text'>{nullCheck(listing[0]?.sector)}</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 pt-3 align-items-start'>
                                    <Col className='d-flex flex-column justify-content-start'>
                                        <div className='font-medium font-size2 color-text'>Part Of Indices</div>
                                        {listing?.length === 0 ?
                                            <div className='font-regular font-size2 color-text'>{nullCheck(null)}</div> :
                                            (
                                                <div className='p-0'>
                                                    {listing[0]?.partOfIndices?.map((item, i) => (
                                                        <span key={i} className='font-regular font-size1 color-text me-1 d-inline-block'>{`${nullCheck(item?.groupname)}${listing[0]?.partOfIndices?.length === i + 1 ? '' : ','}`}</span>
                                                    ))}
                                                </div>
                                            )}
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default CompanyInfo;
